import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from '../../../../shared/comum.module';
import { translateLoaderNBS } from '../../../../shared/translate-loader/translateLoader';
import { AnaliseVendaBi01FiltroComponent } from './analise-venda-bi01-filtro/analise-venda-bi01-filtro.component';
import { AnaliseVendaBi01ListaGridComponent } from './analise-venda-bi01-lista/analise-venda-bi01-lista-grid/analise-venda-bi01-lista-grid.component';
import { AnaliseVendaBi01ListaComponent } from './analise-venda-bi01-lista/analise-venda-bi01-lista.component';
import { AnaliseVendaBi01Service } from './analise-venda-bi01-service/analise-venda-bi01.service';
import { AnaliseVendaBi01Component } from './analise-venda-bi01.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    NgbModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)

  ],
  exports: [
    AnaliseVendaBi01Component,
    AnaliseVendaBi01ListaGridComponent
  ],
  declarations: [
    AnaliseVendaBi01Component,
    AnaliseVendaBi01ListaComponent,
    AnaliseVendaBi01FiltroComponent,
    AnaliseVendaBi01ListaGridComponent
  ],
  providers: [
    AnaliseVendaBi01Service
  ]
})
export class AnaliseVendaBi01Module { }
